export const normalizeMonths = (monthsData: any): { label: string; openDays: number; tjm: number; amount: number }[] => {
    if (Array.isArray(monthsData)) return monthsData;

    return Object.entries(monthsData).map(([key, value]) => ({
      label: key,
      openDays: 0,
      tjm: 0,
      amount: Number(value)
    }));
}